import { Pid } from '../../../../common/models/pid.interface';
import { EntityState } from '../../store/store.utils';
import {
    Event,
    GridPagination,
    EventSearchCriteria,
    EventSearchType
} from '../../../../common/models/event.interface';
import {
    CheckboxGroupSelection,
    DynamicFormState,
    SerializableFormState,
    TextSearchSelection
} from 'quotient-ng-core';
import { CPAConflictError } from '../../../../common/models/api-response.interface';

export const initEventSearchKeyword: TextSearchSelection = {
    searchString: '',
    searchType: EventSearchType.SEARCH_ALL
};

export const initEventSearchGroup: CheckboxGroupSelection[] = [
    {
        groupKey: 'status',
        items: []
    },
    {
        groupKey: 'matchingOffers',
        items: []
    },
    {
        groupKey: 'events',
        items: []
    }
];

export const initialEventState: EventState = {
    ui: {
        eventSearchCriteria: {
            advancedFilters: {
                filters: [],
                filtersActive: 0
            },
            basicFilters: {
                groupList: initEventSearchGroup,
                checkedCount: 0
            },
            keyword: initEventSearchKeyword
        },
        eventGrid: {
            loading: false,
            pagination: {
                pageSize: 10,
                skip: 0
            },
            total: null
        },
        eventDetail: {
            uiMap: {}
        },
        eventCreate: {
            loading: false,
            form: { formState: DynamicFormState.WRITE }
        }
    },
    data: {
        events: {
            idMap: {},
            idSort: []
        },
        pids: {},
        eventTypes: []
    }
};

export interface EventDetailUI {
    loading: boolean;
    form: EventDetailForm;
}

export interface EventDetailForm {
    formState: DynamicFormState;
    serializedForm?: SerializableFormState;
    asyncValidations?: CPAConflictError[];
}

export interface EventState {
    ui: {
        eventSearchCriteria: EventSearchCriteria;
        eventGrid: {
            loading: boolean;
            pagination: GridPagination;
            total: number;
        };
        eventDetail: {
            uiMap: {
                [id: number]: EventDetailUI;
            };
        };
        eventCreate: EventDetailUI;
    };
    data: {
        events: EntityState<number, Event>;
        pids: {
            [id: number]: Pid;
        };
        eventTypes: string[];
    };
}
